import React, { useState } from "react";
import { studentOldPaidFees } from "../../api/Student";
import { closeModal, SweetAlertShow } from "../master/Master";

export default function OldDueFeeModel({ data, handleFunction }) {
    const [formData, setFormData] = useState({
        amount: "",
        remark: "",
    });
    const [loading, setLoading] = useState(false);


    const onChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const submitForm = async (e) => {
        e.preventDefault();

        if (loading) return; // duplicate submit stop

        setLoading(true);
        try {
            const payload = {
                student_id: data?.id,
                amount: formData.amount,
                remark: formData.remark,
                payment_date: formData.payment_date,
            };

            const response = await studentOldPaidFees(payload);

            if (response?.data?.status) {

                SweetAlertShow(
                    "success",
                    "Success",
                    response?.data?.message
                );

                closeModal("OldDueFeeModel");

                setFormData({
                    amount: "",
                    remark: "",
                    payment_date: "",
                });

                handleFunction(); // <-- page data reload


            } else {
                SweetAlertShow(
                    "info",
                    "Warning",
                    response?.data?.message
                );
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ||
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };
    return (
        <div
            className="modal fade"
            id="OldDueFeeModel"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content border-0 shadow">
                    <div className="modal-header bg-label-primary">
                        <h5 className="modal-title">
                            Old Fee Payment Management
                        </h5>

                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                        />
                    </div>

                    <form onSubmit={submitForm}>
                        <div className="modal-body">

                            {/* Current Details */}

                            <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Student Name
                                    </label>

                                    <input
                                        className="form-control"
                                        value={data?.name || ""}
                                        readOnly
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Registration No
                                    </label>

                                    <input
                                        className="form-control"
                                        value={data?.registration_no || ""}
                                        readOnly
                                    />
                                </div>
                            </div>

                            <div className="row g-3 mb-4">
                                <div className="col-md-4">
                                    <div className="border rounded p-3 text-center">
                                        <small className="text-muted d-block">
                                            Old Due Fee
                                        </small>

                                        <h5 className="text-danger mb-0">
                                            ₹
                                            {Number(
                                                data?.old_due_fees || 0
                                            ).toLocaleString()}
                                        </h5>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="border rounded p-3 text-center">
                                        <small className="text-muted d-block">
                                            Old Paid Fee
                                        </small>

                                        <h5 className="text-success mb-0">
                                            ₹
                                            {Number(
                                                data?.old_paid_fees || 0
                                            ).toLocaleString()}
                                        </h5>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="border rounded p-3 text-center">
                                        <small className="text-muted d-block">
                                            Remaining
                                        </small>

                                        <h5 className="text-primary mb-0">
                                            ₹
                                            {Number(
                                                data?.old_due_fees || 0
                                            ).toLocaleString()}
                                        </h5>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">
                                    Previous Remark
                                </label>

                                <textarea
                                    className="form-control"
                                    rows="2"
                                    value={data?.old_fees_remark || "-"}
                                    readOnly
                                />
                            </div>

                            <hr />

                            {/* Payment Entry */}

                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Pay Amount
                                    </label>

                                    <input
                                        type="number"
                                        name="amount"
                                        className="form-control"
                                        placeholder="Enter Amount"
                                        value={formData.amount}
                                        onChange={onChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Payment Date
                                    </label>

                                    <input
                                        type="date"
                                        name="payment_date"
                                        className="form-control"
                                        defaultValue={
                                            new Date()
                                                .toISOString()
                                                .split("T")[0]
                                        }
                                    />
                                </div>

                                <div className="col-12">
                                    <label className="form-label">
                                        Remark
                                    </label>

                                    <textarea
                                        name="remark"
                                        className="form-control"
                                        rows="3"
                                        placeholder="Enter Remark"
                                        value={formData.remark}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}